import { render, staticRenderFns } from "./MaintenanceView.vue?vue&type=template&id=37b36eef&scoped=true&"
import script from "./MaintenanceView.vue?vue&type=script&lang=js&"
export * from "./MaintenanceView.vue?vue&type=script&lang=js&"
import style0 from "./MaintenanceView.vue?vue&type=style&index=0&id=37b36eef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b36eef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
